import axios from "axios";

export const get_chat_history = () => dispatch => {
    return axios
        .get(
            "/api/ai/chat",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "SET_CHAT_HISTORY",
                history: res.data
            });
        })
        .catch(err => {
            console.log(err);
        });
};


export const add_chat_message = (role, message) => dispatch => {
    dispatch({
        type: "ADD_CHAT_MESSAGE",
        role: role,
        content: message
    });
}
export const remove_last_chat_message = () => dispatch => {

    dispatch({
        type: "REMOVE_LAST_CHAT_MESSAGE"
    });
}

export const submit_chat_message = (message) => dispatch => {
    return axios
        .post(
            "/api/ai/chat",
            {
                message
            },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "ADD_CHAT_MESSAGE",
                role: res.data.role,
                content: res.data.content
            });
        })
        .catch(err => {
            dispatch({
                type: "ADD_CHAT_ERROR",
                error: err.response.data.error
            });
        });
};

export const clear_chat_error = () => dispatch => {
    dispatch({
        type: "CLEAR_CHAT_ERROR"
    });
}
export const reset_chat = () => dispatch => {
    return axios
        .delete(
            "/api/ai/chat",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "SET_CHAT_HISTORY",
                history: res.data
            });
        })
        .catch(err => {
            console.log(err);
        });
};